import type { FaireProductEntity } from "../../entity_types/product";

export const p_xe3chm3d2e: FaireProductEntity = {
  token: "p_xe3chm3d2e",
  type: "product",
  name: "Hamsa Hand & Heart Evil Eye Design Hair Clip",
  brandToken: "b_xttg6nwn4k",
  brandName: "SoapElenGlen",
  imageUrl: "https://cdn.faire.com/fastly/289cd3f7054bca3a9c3c9de0bc0ccb21ebf4dedc5205a6f6857d9d48db971d5b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/477241a9a08b278f414a23edc4481e513c633a1824bc4387a4255ce4b971dfdd.jpeg",
    "https://cdn.faire.com/fastly/32b7e048f08660c6cbd9856b7c3cbd5c568f8ce4aa40b2cffa7e37b3bec7c9e7.jpeg",
    "https://cdn.faire.com/fastly/d68101eb9e78dd6b2ebb6c94e1508bd5a9438e34e9b37991bcad677a4cf20dcc.jpeg",
    "https://cdn.faire.com/fastly/e87d94c5b603b56cc4a80c80a46934cd50aa86770a32ea6f17ad6c027bac8ff9.jpeg",
    "https://cdn.faire.com/fastly/d5deb1cd15fc4a83fdb1a6d0afac3d76215d811748934e4116519b9eeee3b16f.jpeg",
    "https://cdn.faire.com/fastly/e4374c0b6bad2cdd240b9a866ab820dd6bf78aacaad6d90cd219310c2f09e6b2.jpeg"
  ],
  priceDollars: 3.23,
  description: "🌿 Material:  Acrylic\n\n📏 Size & Weight:  7-8cm, 25g\n\n💖 Design Features:\n\nAdd a touch of mystique and protection to your hairstyle with these Evil Eye & Hamsa Hair Claws—featuring iconic protective motifs (evil eye, hamsa hand, heart shape) in sleek, glossy finishes, accented with vibrant blue and subtle decorative details. The sturdy claw structure keeps hair securely in place, while the culturally symbolic designs bring a unique, stylish edge to daily looks. Perfect for adding a meaningful, eye-catching accent to any hairstyle.\n\n🎨 Suitable Occasions: Perfect for daily wear, work, parties, casual outings, or as a thoughtful gift for friends and loved ones.\n\n📦 Packaging: Default single-piece packaging",
  tags: [],
  msrpDollars: 6.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:52.716Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
